import React from "react";

export default function MetLifeEOIRequest() {
    return (
        <div className="page-wrapper">
            <br />
            <p>
                We are currently experiencing a temporary issue with the connection to
                MetLife’s Evidence of Insurability (EOI) application system. Please contact
                the ALPA Member Insurance Department at{" "}
                <a href="mailto:insurance@alpa.org">insurance@alpa.org</a>. Our team will
                provide you with the appropriate MetLife application and instructions for
                completion. We apologize for the inconvenience and appreciate your patience
                while this issue is being resolved.
            </p>
        </div>
    );
}